import 'jquery-match-height';

export const init = ($target) => {

	var option = {
		byRow: true,
		property: 'min-height',
		target: null,
		remove: false,
	};

	$target.find('.b-ambasador__annot').matchHeight(option);

};
